<template>
    <aside
        :class="{moving: topBarIsRendered, sidebarCollapsed: burgerMenuAllowedAndClosed}"
        class="main-sidebar"
        style="overflow: auto;"
    >
        <!--   <v-bar wrapper="v-bar-wrapper"
           vBar=""
           vBarInternal=""
           hBar=""
           hBarInternal=""> -->
        <div
            v-bar
            class="vuebar-element"
        >
            <!-- sidebar: style can be found in sidebar.less -->
            <div>
                <section class="sidebar">
                    <!-- Sidebar user panel -->
                    <div
                        :style="{backgroundColor: logoFileBackgroundColor}"
                        :class="{'user-panelCollapsed': burgerMenuAllowedAndClosed}"
                        class="user-panel"
                    >
                        <div
                            class="image"
                            style="min-height: 100px;"
                        >
                            <img
                                :src="logoFile"
                                alt="User Image"
                            >
                        </div>
                        <!-- class="img-circle" -->
                        <div class="info">
                            <p
                                :class="{nameCollapsed: burgerMenuAllowedAndClosed}"
                                class="name"
                            >{{ sidebarName }}</p>
                            <div v-show="!(burgerMenuAllowedAndClosed)">
                                <span v-if="enableOptions">
                                    <router-link :to="{name: 'settings'}">
                                        <i
                                            :class="[$route.name === 'settings' ? '   activate-link': '']"
                                            class="ti-panel"
                                        ></i>
                                        <small>{{ getVerbose('sidebar_settings_menu') }}</small>
                                    </router-link>
                                </span>
                                <span v-if="displayAlerts || displayAlarms">
                                    <router-link v-if="displayAlerts" :to="{name: 'alerts'}">

                                        <ns-loader
                                            :toLoad="toLoad"
                                            :scoped="$store.getters.userIsAtLeastAdmin ? false : true"
                                            @dataFetched="onDataFetched"
                                            :fetchTimer="10000"
                                        >
                                            <div
                                                slot="loader"
                                            >
                                            </div>
                                            <div
                                                slot="error"
                                            >

                                            </div>
                                            <template slot="content">
                                                <el-badge
                                                    v-if="nbActiveAlerts > 0"
                                                    :value="nbActiveAlerts"
                                                    :max="99"
                                                    class="item alert-badge"
                                                ></el-badge>
                                                <el-badge
                                                    v-else
                                                    :value="0"
                                                    :max="99"
                                                    class="item alert-badge"
                                                    style="visibility: hidden;"
                                                ></el-badge>
                                            </template>
                                        </ns-loader>
                                        <i
                                            :class="[$route.name === 'alerts' ? 'activate-link': '']"
                                            class="ti-alert"
                                        ></i>
                                        <small>{{ getVerbose('sidebar_alerts_menu') }}</small>
                                    </router-link>
                                    <router-link v-if="displayAlarms" :to="{name: 'alarms'}">
                                        <el-badge
                                            v-if="alarms > 0"
                                            :value="alarms"
                                            :max="99"
                                            class="item alert-badge"></el-badge>
                                        <i
                                            :class="[$route.name === 'alarms' ? 'activate-link': '']"
                                            class="ti-bell"
                                        ></i>
                                        <small>{{ getVerbose('sidebar_alarms_menu') }}</small>
                                    </router-link>
                                </span>
                                <span v-else>
                                    <router-link :to="{name: 'profile'}">
                                        <i
                                            :class="[$route.name === 'profile' ? 'activate-link': '']"
                                            class="ti-user"
                                        ></i>
                                        <small>{{ getVerbose('sidebar_profile_menu') }}</small>
                                    </router-link>
                                    <a
                                        href="#"
                                        @click="logout"
                                    ><i class="ti-power-off" ></i><small>{{ getVerbose('sidebar_logout_menu') }}</small></a>
                                </span>
                            </div>
                        </div>
                        <img
                            :src="backgroundFile1"
                            class="bg-user"
                            alt="User Image"
                        >
                    </div>
                    <el-menu
                        ref="el-menu"
                        :default-active="getMenuActivated"
                        :background-color="menuItemColors.background"
                        :text-color="menuItemColors.text"
                        :active-text-color="menuItemColors.activeText"
                        class="sidebar-menu"
                    >
                        <slot name="sidebar-menu-0"></slot>
                        <router-link
                            v-if="$store.getters.userIsAtLeastManager && enableUsersAdministration &&
                            enableUsersSideBarMenu"
                            :to="{ name: 'user-list'}"
                            tag="div"
                        >
                            <el-menu-item index="100">
                                <i
                                    :class="[$route.name === 'user-list' ? 'activate-link': '']"
                                    class="ti-user"
                                ></i>
                                <span v-if="!(burgerMenuAllowedAndClosed)">{{ getVerbose('sidebar_users_menu') }}</span>
                            </el-menu-item>
                        </router-link>

                        <router-link
                            v-if="$store.getters.userIsAtLeastManager && enableGroupsAdministration &&
                            enableGroupsSideBarMenu"
                            :to="{ name: 'group-list'}"
                            tag="div"
                        >
                            <el-menu-item index="101">
                                <i
                                    :class="[$route.name === 'group-list' ? 'activate-link': '']"
                                    class="ti-id-badge"
                                ></i>
                                <span v-if="!(burgerMenuAllowedAndClosed)">{{ getVerbose('sidebar_groups_menu') }}</span>
                            </el-menu-item>
                        </router-link>

                        <router-link
                            v-if="$store.getters.userIsAtLeastManager && enablePermissionAdministration"
                            :to="{ name: 'permission'}"
                            tag="div"
                        >
                            <el-menu-item index="102">
                                <i
                                    :class="[$route.name === 'permission' ? 'activate-link': '']"
                                    class="ti-id-badge"
                                ></i>
                                <span v-if="!(burgerMenuAllowedAndClosed)">{{ getVerbose('sidebar_permissions_menu') }}</span>
                            </el-menu-item>
                        </router-link>
                    </el-menu>
                </section>
                <!-- /.sidebar -->
            </div>
        </div>
        <span class="package-version">{{ version }}</span>
    </aside>
</template>

<script>
/*global VERSION:true*/
import { mapGetters } from 'vuex';
import NsLoader from '../../partials/ns-vue-loader.vue';
export default {
    name: 'DashboardSidebar',
    components: {NsLoader,},
    data (){
        return {
            nbActiveAlerts: 0,
            alertsArray : [],
            firstLoad: true,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
            'sidebarName',
            'topBarIsRendered',
            'logoFile',
            'showAlerts',
            'showAlarms',
            'backgroundFile1',
            'autoConnectionToFirstEntity',
            'menuOptions',
            'menuItemColors',
            'getMenuActivated',
            'enableUsersAdministration',
            'enableUsersSideBarMenu',
            'enableGroupsAdministration',
            'enablePermissionAdministration',
            'enableGroupsSideBarMenu',
            'logoFileBackgroundColor',
            'allowAlertsAlarmsNotification',
            'getVerbose',
            'alertsFetchSidebarFilter',
            'enableOptions',
            'alarmSidebarFilter',
        ]),

        toLoad (){
            return [{
                model: 'alerts',
                name: 'alerts',
                stats: this.allowAlertsAlarmsNotification === false,
                filters: {
                    ...this.alertsFetchSidebarFilter
                }
            }];
        },
        displayAlerts(){
            if (this.$store.getters.userIsAtLeastManager && this.showAlerts) {
                return true;
            }
            return false;
        },
        displayAlarms(){
            if (this.$store.getters.userIsAtLeastManager && this.showAlarms) {
                return true;
            }
            return false;
        },

        version (){
            try{
                return VERSION;
            }catch(e){
                console.debug(e);
                return '';
            }
        },

        getNbNonAcquitedAlerts() {
            return this.$store.getters.alerts.filter((alert) => {
                return alert.acquited === false && alert.archived === false;
            }).length;
        },
        alarms (){
            return this.alarmSidebarFilter;
        },
    },
    watch: {
    },

    mounted() {
        if (this.$store.getters.userIsAtLeastManager && this.showAlarms) {
            this.addAlarmsToMeta();
        }
        if (this.$store.getters.userIsAtLeastManager && this.showAlerts) {
            this.addAlertsToMeta();
        }
    },
    beforeDestroy() {
        if (this.$store.state.api.meta.listModels.alarms) {
            this.$store.dispatch('removeMetaModel', 'alarm');
        }
        if (this.$store.state.api.meta.listModels.alerts) {
            this.$store.dispatch('removeMetaModel', 'alert');
        }
    },
    methods:{
        getDiff(newObjects, oldObjects) {
            return newObjects.map(newObject => {
                let existingObject = oldObjects.find(oldObject => {
                    return oldObject.uid === newObject.uid;
                });
                return existingObject === undefined;
            });
        },
        addAlarmsToMeta() {
            this.$store.dispatch('addMetaModel', 'alarm');
        },
        addAlertsToMeta() {
            this.$store.dispatch('addMetaModel', 'alert');
        },
        logout(){
            this.$store.dispatch('logoutUser');
        },

        onDataFetched (res){
            if (this.allowAlertsAlarmsNotification) {
                this.nbActiveAlerts = res.alerts.length;
                this.$set(this, 'alertsArray', res.alerts);
            }
            else {
                this.nbActiveAlerts = res.alerts;
            }
        }
    }
};
</script>

<style lang="scss" >
.v-bar-wrapper {
    height: 100%;
}

.main-sidebar {
    transition: ease-in-out .3s width, padding-top ease 1s !important;
    .package-version{
        color: rgb(255, 255, 255);
        position: absolute;
        bottom: 5px;
        left: 5px;
    }

    .activate-link{
        color: #ffd04b;
    }
    .activate-link + small{
        color: #ffd04b;
    }
    .activate-link + span{
        color: #ffd04b;
    }

    /* put those in !important to start fixing elem UI issues */

    .alert-badge{
      position: absolute !important;
    }

    .el-badge__content {
        border: 0px !important;
        background-color: #f35858;
        font-weight: 500;
    }
    .sidebar {
        .user-panel {
                transition: padding-bottom .3s ease-in-out;
            .name {
                transition: all .3s ease-in-out;
            }
            .nameCollapsed {
                transform: rotate(-90deg);
                margin-left: -15px;
            }
        }
        .user-panelCollapsed {
            padding-bottom: 10px;
        }
    }
}
.sidebarCollapsed {
    width: 60px !important;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/layouts/dashboard/Sidebar.vue